import { Intent, Spinner } from "@blueprintjs/core";
import autobind from "autobind-decorator";
import { Component } from "react";
import omit from "lodash/omit";

import { Query } from "core/api/typedQuery";
import EntityForm from "core/components/EntityForm";
import TokenSession from "../../../../core/util/session/TokenSession";
import { ForumToaster } from "../../forumActions";
import { ForumSubscription } from "panels/forum/entity/ForumSubscription";


interface IForumSubscriptionFormProps {
	forumId: number;
	onAfterSave?: (forumSub: ForumSubscription) => void;
}

const SubQuery = Query.queryMany<ForumSubscription, {forumId: number}>(ForumSubscription);

export default class ForumSubscriptionForm extends Component<IForumSubscriptionFormProps> {

	constructor(props) {
		super(props);
	}

	@autobind
	private onBeforeSave(sub: ForumSubscription) {
		const s = {...sub};
		
		s.forum = this.props.forumId;

		// temp. sservice should do this automatically on backend
		s.user = TokenSession.getUserId();

		// temp. service should accept same data type for query and mutation
		return omit(s, "forumEntity");
	}

	@autobind
	public onAfterSave(result: ForumSubscription) {

		ForumToaster.show({
			intent: Intent.SUCCESS,
			message: "Forum subscription updated"
		});

		if(this.props.onAfterSave) {
			this.props.onAfterSave(result);
		}
	}

	public render() {
		return (
			<SubQuery params={{forumId: this.props.forumId}}>
				{
					({data, loading}) => loading ? (
						<Spinner />
					) : (
						<EntityForm instance={data && data.length && data[0]} clazz={ForumSubscription} refetch={false} beforeSave={this.onBeforeSave} afterSave={this.onAfterSave} />
					)
				}
			</SubQuery>
		);
	}
}




// WEBPACK FOOTER //
// ./src/panels/forum/component/subscriptions/ForumSubscriptionForm.tsx